import $ from 'jquery';
export default {
    name: 'rendez-vous',
    components: {},
    props: {
        is_start: Number
    },
    data() {
        return {
            rendez_vous: "",
            save_loading: false,
            checked: false,
            loading: false,

        }
    },
    computed: {
        patient(){
            return this.$store.getters["patient"]
        },

        consultation() {
            return this.$store.getters["consultationPatientEnCours"];
        },

        consultationEnCours(){
            return this.$store.getters['consultationPatientEnCours']
        },

        /**
         * User Info
         * @returns 
         */
        userCredentials() {
            return this.$store.getters['authInfo'];
        },
    },
    mounted() {

    },
    methods: {

        endConsultation() {
            this.save_loading = true
            
            let constantes = this.$store.getters["formConstantesRempli"];
            let grossesse = this.$store.getters["formGrossessesRempli"];
            if (constantes.length == 0) {
                this.doErrorMsg("Veuillez remplir et enregistrer  la section 'Constantes'");
                this.save_loading = false
            } else if (grossesse.length == 0) {
                this.doErrorMsg("Veuillez remplir et enregistrer la section 'Grossesse'");
                this.save_loading = false
            } else {
                /* this.$store.dispatch("endConsultation", { consultation_id, date_rdv_to_send }).then(() => {
                    this.save_loading = false
                    this.doSuccessMsg('Cette consultation a été terminée.')
                    this.$router.push({ "path": "/dashboard" })
                }) */
                $('#fin-consultation').modal('show')
            }

        },

        endConsultationModal(){
            // let consultation_id = this.consultation.id;
            // let date_rdv_to_send = null
            // if(this.rendez_vous !=="")
            // {
            //     date_rdv_to_send = this.dateFormatToSend(this.rendez_vous).date_to_send;
            // } else {
            //     date_rdv_to_send ='0'
            // }

            const data = {
                date_heure: this.rendez_vous,
                medecin: {
                    nom: this.userCredentials.name,
                    titre: this.userCredentials.titre
                },
                patient: {
                    nom_patient: this.patient.nom+' '+this.patient.prenoms,
                    sexe: (this.patient.sexe_id == 1)?'H':(this.patient.sexe_id == 2)?'F':'',
                    telephone: this.patient.telephone_mobile,
                    num_dossier: this.patient.code
                }
            }
            console.log(data);

            this.loading = true

            this.$store.dispatch('saveNextRDV', data).then((response) => {
                if (response.success) {
                    this.$refs.modalEndConsultation.click()
                    setTimeout(() => {
                        this.successToast("Prise de rendez-vous effectuée avec succès")
                    }, 200);
                    
                } else {
                    this.errorToast("Une erreur s'est produite ! Merci de réessayer")
                }


                this.loading = false
            }) 
            
            
            // if(this.checked === false){
            //     $('.err-msg').fadeIn()
            // } else {
            //     this.loading = true
            //     // this.$store.dispatch("endConsultation", { consultation_id, date_rdv_to_send }).then(() => {
            //     //     this.loading = false
            //     //     this.$refs.modalEndConsultation.click()
            //     //     this.doSuccessMsg('Cette consultation a été terminée. Le prochain rendez-vous est programmé.')
            //     //     this.$router.push({ "path": "/dashboard" })
            //     // }) 

            //     setTimeout(() => {
            //         this.$refs.modalEndConsultation.click()
            //         this.loading = false
            //         setTimeout(() => {
            //             this.successToast("Prise de rendez-vous effectuée avec succès")
            //         }, 100);
            //     }, (600));
            // }

            

            

        },

        /**
         * Vérification de la prise en charge du patient
         */
        changedChecked(){
            if(this.checked ===true){
                $('.err-msg').fadeOut()
            }
        },

        programmerProchainRdv() {
            this.$refs.form.validate().then((success) => {

                if (!success) {
                    return;
                }

                //control the dates
                let today = new Date()
                let date_rdv = this.dateFormatToSend(this.rendez_vous).date
                


                if (today > date_rdv) {
                    this.doErrorMsg(
                        "La date du prochain rendez-vous doit être postérieure à la date d'aujourd'hui"
                    )
                    return;
                }

                this.save_loading = true;
                $('#fin-consultation').modal('show')
                
                // let constantes = this.$store.getters["formConstantesRempli"];
                // let grossesse = this.$store.getters["formGrossessesRempli"];
                // console.log('const', constantes);
                // console.log('grossesse', grossesse);
                // if (constantes.length == 0) {
                //     this.doErrorMsg("Veuillez remplir et enregistrer  la section 'Constantes'");
                //     this.save_loading = false
                    
                // } else if (grossesse.length == 0) {
                //     this.doErrorMsg("Veuillez remplir et enregistrer la section 'Grossesse'");
                //     this.save_loading = false
                // } else {
                //     /* this.$store.dispatch("endConsultation", { consultation_id, date_rdv_to_send }).then(() => {
                //         this.save_loading = false
                //         this.doSuccessMsg('Cette consultation a été terminée. Le prochain rendez-vous est programmé.')
                //         this.$router.push({ "path": "/dashboard" })
                //     }) */
                    
                // }

            });
        },

        doSuccessMsg: function(msg) {
            this.$toasted.show(msg, {
                action: [{
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }],
                position: 'top-center',
                duration: 5000,
                theme: 'toasted-primary',
                type: 'success'
            })
        },
        doErrorMsg: function(msg) {
            this.$toasted.show(msg, {
                action: [{
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }],
                position: 'top-center',
                duration: 5000,
                theme: 'toasted-primary',
                type: 'error'
            })
        },

        dateFormatToSend: function(given_date) {
            let date = new Date(given_date)
            let month = date.getMonth() + 1,
                day = date.getDate();

            if (month < 10) month = '0' + month
            let date_to_send = `${date.getFullYear()}-${month}-${day}
                                        `;
            return { date: date, date_to_send: date_to_send }
        }
    }
}